module.exports = __webpack_public_path__ + "static/npa-f1bd38d24296829256933c7b0242a9ce.png";